import React from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const initialValues = {
    name: data?.name || '',
  };

  const inputFields = [
    {
      name: 'name',
      label: 'Tyre Location',
      type: 'text',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={
        data ? 'Update Tyre Location' : 'Add Tyre Location'
      }
      url={'tyre-location'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="tyre-locations"
      inputFields={inputFields}
      data={initialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
